<div class="rbac-page">
  <div class="rbac-page__header">
    <div>
      <button type="button" class="rbac-back" (click)="back.emit()">&larr; Back to Modules</button>
      <h4>Sub-Modules — {{ module.name }}</h4>
    </div>
    <button type="button" class="rbac-btn rbac-btn--primary" (click)="openAdd()">+ Add Sub-Module</button>
  </div>

  <app-rbac-table
    [columns]="columns"
    [rows]="subModules"
    [loading]="loading"
    emptyMessage="No sub-modules for this module yet."
    (edit)="openEdit($event)"
    (delete)="onDelete($event)"
    (toggleStatus)="onToggleStatus($event)"
    (rowSelect)="manageInnerModules.emit($event)">
  </app-rbac-table>
  <p class="rbac-page__hint">Click a row to manage its inner modules.</p>
</div>

<app-rbac-modal [open]="modalOpen" (closed)="closeModal()">
  <app-rbac-form
    [title]="editingSubModule?.id ? 'Edit Sub-Module' : 'Add Sub-Module'"
    [fields]="fields"
    [model]="editingSubModule"
    [saving]="saving"
    (save)="onSave($event)"
    (cancel)="closeModal()">
  </app-rbac-form>
</app-rbac-modal>
